function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "dateFormat", function () {
  return $5c580aeb1df105e0$export$4e4cb19dd88cd821;
});
$parcel$export(module.exports, "dateFormatWithComma", function () {
  return $5c580aeb1df105e0$export$31aff849042d002b;
});
$parcel$export(module.exports, "dateFormatWithoutYear", function () {
  return $5c580aeb1df105e0$export$62d471975ca764de;
});
$parcel$export(module.exports, "timeFormat", function () {
  return $5c580aeb1df105e0$export$94f4d87fad5dcf9a;
});
$parcel$export(module.exports, "UTC_TYPEAHEAD_OPTION", function () {
  return $5c580aeb1df105e0$export$e608a70d30657848;
});
$parcel$export(module.exports, "FORMATS", function () {
  return $5c580aeb1df105e0$export$e9c4b7b466aa8274;
});
$parcel$export(module.exports, "METRICS_PRECISION_MAP", function () {
  return $5c580aeb1df105e0$export$79c65e616cfb46c4;
});
var $5c580aeb1df105e0$export$4e4cb19dd88cd821 = 'MMM D YYYY';
var $5c580aeb1df105e0$export$31aff849042d002b = 'MMM D, YYYY';
var $5c580aeb1df105e0$export$62d471975ca764de = 'MMM D';
var $5c580aeb1df105e0$export$94f4d87fad5dcf9a = 'h:mma'; // <option> data structure for the UTC timezone
var $5c580aeb1df105e0$export$e608a70d30657848 = {
  value: 'Etc/UTC',
  label: 'UTC'
};
var $5c580aeb1df105e0$export$e9c4b7b466aa8274 = {
  /** @deprecated */MOMENT: {
    SHORT_DATE: 'YYYY-MM-DD',
    TIME: $5c580aeb1df105e0$export$94f4d87fad5dcf9a,
    LONG_DATETIME_ALT: 'MMM DD, YYYY [at] h:mma',
    INPUT_DATES: ['YYYY-MM-DD'],
    INPUT_TIMES: ['h:mma', 'H:mm', 'H:mma'],
    INPUT_DATETIMES: ['YYYY-MM-DD h:mma', 'YYYY-MM-DD H:mm', 'YYYY-MM-DD H:mma'],
    DATE_FORMAT: $5c580aeb1df105e0$export$4e4cb19dd88cd821,
    DATE_FORMAT_WITH_COMMA: $5c580aeb1df105e0$export$31aff849042d002b,
    DATE_FORMAT_WITHOUT_YEAR: $5c580aeb1df105e0$export$62d471975ca764de
  },
  DATE_FNS: {
    SHORT_DATE: 'yyyy-MM-dd',
    TIME: 'h:mmaaa',
    LONG_DATETIME_ALT: "MMM dd, yyyy 'at' h:mmaaa",
    DATE_FORMAT: 'MMM d yyyy',
    DATE_FORMAT_WITH_COMMA: 'MMM d, yyyy',
    DATE_FORMAT_WITHOUT_YEAR: 'MMM d',
    ISO8601: "yyyy-MM-dd'T'HH:mm:ssX",
    ISO8601_OFFSET: "yyyy-MM-dd'T'HH:mm:ssxxx",
    API_DATE_FORMAT: "yyyy-MM-dd'T'HH:mm",
    DATE: 'MMM do',
    DATETIME_WITH_YEAR: 'MMM do yyyy h:mma',
    DATETIME_WITHOUT_YEAR: 'MMM d, h:mmaaa',
    LONG_DATETIME: "MMM do yyyy h:mmaaaaa'm'",
    //date-fns //Bug with date-fns. token "a" not outputing lowercase
    LONG_DATETIME_WITH_COMMA: 'MMM d yyyy, h:mmaaa'
  }
};
var $5c580aeb1df105e0$export$79c65e616cfb46c4 = [{
  time: 480,
  value: '1min',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'ha',
  outputFormat: 'haaa'
}, {
  time: 14400,
  value: 'hour',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'ha',
  outputFormat: 'haaa'
}, {
  time: 47520,
  value: 'day',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM Do',
  outputFormat: 'MMM do'
}, {
  time: 273600,
  value: 'week',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM Do',
  outputFormat: 'MMM do'
}, {
  time: Infinity,
  value: 'month',
  /** @deprecated use `outputFormat` for date-fns format  */format: 'MMM YY',
  outputFormat: 'MMM yy'
}];